module.exports = __webpack_public_path__ + "static/media/cases_3d_keslon_04b.e80b02df.jpg";